"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apiService_1 = __importDefault(require("@common/services/apiService"));
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("@/react-app/common/components/Button"));
var EvaTable_1 = __importDefault(require("@/react-app/common/components/EvaTable"));
var TablePagination_1 = __importDefault(require("@/react-app/common/components/EvaTable/TablePagination"));
var Loading_1 = __importDefault(require("@/react-app/common/components/Loading"));
var dataStoring_1 = require("@/react-app/common/services/dataStoring");
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
var store_1 = require("@/redux/store");
var fromDateUtil_1 = require("../ItemLogPage/util/fromDateUtil");
var DeleteQueueModal_1 = __importDefault(require("./DeleteQueueModal"));
var QueueNameModal_1 = __importDefault(require("./QueueNameModal"));
var QueueSearchInput_1 = __importDefault(require("./QueueSearchInput"));
var queuesSlice_1 = require("./state/queuesSlice");
var constants_1 = require("./constants");
var Columns_1 = require("./Columns");
var NoData_1 = __importDefault(require("@/react-app/common/components/NoData"));
var NoResults_1 = __importDefault(require("@/react-app/common/components/NoResults"));
var HasError_1 = __importDefault(require("@/react-app/common/components/HasError"));
var date_1 = require("@/react-app/common/utils/date/date");
function default_1(_a) {
    var _this = this;
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, currentUser = _a.currentUser;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, store_1.useAppDispatch)();
    var queues = (0, react_redux_1.useSelector)(queuesSlice_1.queuesSelector);
    var queueRules = (0, react_redux_1.useSelector)(queuesSlice_1.queueRulesSelector);
    var isLoading = (0, react_redux_1.useSelector)(queuesSlice_1.loadingQueuesSelector);
    var error = (0, react_redux_1.useSelector)(queuesSlice_1.errorQueuesSelector);
    var _b = __read((0, react_1.useState)(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = __read((0, react_1.useState)(), 2), selectedQueueToRemove = _c[0], setSelectedQueueToRemove = _c[1];
    var _d = __read((0, react_1.useState)(), 2), selectedQueueToEdit = _d[0], setSelectedQueueToEdit = _d[1];
    var _e = __read((0, react_1.useState)(''), 2), searchText = _e[0], setSearchText = _e[1];
    var _f = __read((0, react_1.useState)(1), 2), page = _f[0], setPage = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), isQueueNameModalOpen = _g[0], setIsQueueNameModalOpen = _g[1];
    var storingOpt = (0, dataStoring_1.useGetDataStoringOptionQuery)(domain).data;
    var minDate = (0, react_1.useMemo)(function () {
        if (storingOpt) {
            return (0, fromDateUtil_1.minDateFromPeriod)(storingOpt.period);
        }
        return null;
    }, [storingOpt]);
    var transformedRules = queueRules.map(function (item) { return (__assign(__assign({}, item), { from: (0, fromDateUtil_1.maxFromDate)(item.lastModifiedTime, minDate) })); });
    var transformedQueues = queues.map(function (item) {
        var _a;
        return (__assign(__assign({}, item), { nameSort: (_a = item.label) === null || _a === void 0 ? void 0 : _a.toLowerCase(), oldestSort: item.oldest ? new Date(item.oldest).getTime() : Infinity, oldestFormatted: item.oldest && (0, date_1.formatDate)(new Date(item.oldest)), oldestHumanized: item.oldest ? (0, date_fns_1.formatDistanceToNow)(new Date(item.oldest), { addSuffix: true }) : '-' }));
    });
    var filteredQueues = transformedQueues.filter(function (item) {
        var _a;
        return (_a = item.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase());
    });
    var totalCount = filteredQueues.length;
    var editHref = function (queue) {
        return angularJsDependencies.href('app.assignment.manual.queue', {
            domain: domain,
            queueId: queue.id,
        });
    };
    var columnRenderer = function (row, column, index) {
        switch (column) {
            case 'nameSort':
                return react_1.default.createElement(Columns_1.NameSortColumn, { row: row, editHref: editHref, key: index });
            case 'count':
                return react_1.default.createElement(Columns_1.CountColumn, { row: row, editHref: editHref, key: index });
            case 'oldestSort':
                return react_1.default.createElement(Columns_1.OldestColumn, { row: row, editHref: editHref, key: index });
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    var handleSearchInput = function (event) {
        setSearchText(event.target.value);
        setPage(1);
    };
    var editQueueName = function (queueName) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedQueueToEdit)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.putQueue({ domain: domain, queueId: selectedQueueToEdit.id }, { queueName: queueName })];
                case 2:
                    _a.sent();
                    dispatch((0, queuesSlice_1.fetchQueues)(domain));
                    notifier_1.default.success(t('MANUAL.EDIT_QUEUE_POPOVER.SUCCESS_TEXT'));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    notifier_1.default.error(t('MANUAL.EDIT_QUEUE_POPOVER.FAIL_TEXT'));
                    return [3 /*break*/, 4];
                case 4:
                    setIsQueueNameModalOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var addQueue = function (queueName) { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService_1.default.postQueue({ domain: domain }, { queueName: queueName })];
                case 1:
                    _a.sent();
                    dispatch((0, queuesSlice_1.fetchQueues)(domain));
                    notifier_1.default.success(t('MANUAL.ADD_QUEUE_POPOVER.SUCCESS_TEXT'));
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    notifier_1.default.error(t('MANUAL.ADD_QUEUE_POPOVER.FAIL_TEXT'));
                    return [3 /*break*/, 3];
                case 3:
                    setIsQueueNameModalOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // We need it for  very specific case => in the queue Table we should not render the edit and delete icons for 'default' and 'escalated' queues
    var handleShowEditAndDeleteIcons = function (row) {
        return row.id !== 'default' && row.id !== 'escalated';
    };
    (0, react_1.useEffect)(function () {
        dispatch((0, queuesSlice_1.fetchQueues)(domain));
    }, [domain]);
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            var currentUrl = window.location.href;
            if (currentUrl.includes('/manual') && currentUrl.includes(domain)) {
                dispatch((0, queuesSlice_1.fetchQueues)(domain, true));
            }
        }, constants_1.INTERVAL_RELOAD_QUEUES);
        return function () {
            clearInterval(interval);
        };
    }, []);
    var total = filteredQueues.length;
    var noData = total === 0 && searchText.length === 0 && !error && !isLoading;
    var noResults = total === 0 && searchText.length > 0 && !error && !isLoading;
    var userCanEditOrDeleteQueue = angularJsDependencies.userPermissionManager.getPermissionForOperation('manual:settings', domain).canWrite;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "row manual-queues-header" },
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement("h1", { className: "manual-title" }, t('MANUAL.QUEUE_LIST_PAGE_BODY.TITLE')),
                userCanEditOrDeleteQueue && (react_1.default.createElement("span", { className: "pull-right" },
                    react_1.default.createElement(Button_1.default, { text: t('MANUAL.QUEUE_LIST_PAGE_BODY.ADD_QUEUE_ICON_TOOLTIP'), onClick: function () {
                            setIsQueueNameModalOpen(true);
                            setSelectedQueueToEdit(undefined);
                        } }))))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12 clearfix table-input search-section local-search-list" },
                react_1.default.createElement(QueueSearchInput_1.default, { value: searchText, onChange: handleSearchInput, placeholder: t('MANUAL.QUEUE_LIST_PAGE_BODY.FILTER_PLACEHOLDER') }),
                total > 0 && react_1.default.createElement(TablePagination_1.default, { totalCount: totalCount, limit: constants_1.limit, page: page, setPage: setPage }))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12 empty-ng-table" },
                noData && react_1.default.createElement(NoData_1.default, { title: t('MANUAL.QUEUE_LIST_PAGE_BODY.NO_DATA_TEXT') }),
                noResults && (react_1.default.createElement(NoResults_1.default, { title: t('MANUAL.QUEUE_LIST_PAGE_BODY.NO_RESULT_TEXT'), linkText: t('MANUAL.QUEUE_LIST_PAGE_BODY.NO_RESULT_LINK'), linkClickHandler: function () { return setSearchText(''); } })),
                error && (react_1.default.createElement(HasError_1.default, { btnText: t('MANUAL.QUEUE_LIST_PAGE_BODY.HAS_ERROR_BTN'), title: t('MANUAL.QUEUE_LIST_PAGE_BODY.HAS_ERROR_TEXT'), btnHandler: function () { return dispatch((0, queuesSlice_1.fetchQueues)(domain)); } })),
                total > 0 && (react_1.default.createElement("div", { className: "local-search-list", "data-cy": "queues-table" },
                    react_1.default.createElement(EvaTable_1.default, { data: filteredQueues, columns: constants_1.queuesColumns, limit: constants_1.limit, columnRenderer: columnRenderer, handleDelete: userCanEditOrDeleteQueue
                            ? function (item) {
                                setSelectedQueueToRemove(item);
                                // disatch(action).then(() is executed in Error cases too that is it's better to pass cb function so we can control when to open the modal
                                var cb = function () { return setIsModalOpen(true); };
                                dispatch((0, queuesSlice_1.searchRulesByQueueAndReloadQueues)(domain, item.id, cb));
                            }
                            : undefined, handleEdit: userCanEditOrDeleteQueue
                            ? function (item) {
                                setSelectedQueueToEdit(item);
                                setIsQueueNameModalOpen(true);
                            }
                            : undefined, domain: domain, entity: "manualModerationQueues", currentUser: currentUser, defaultTableSorting: { nameSort: 'asc' }, page: page, setPage: setPage, showEditAndDeleteIcons: handleShowEditAndDeleteIcons, deleteIconCy: "delete-queue" }))),
                isLoading && react_1.default.createElement(Loading_1.default, null))),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { className: "queues-explanation row" },
            react_1.default.createElement("div", { className: "col-md-5" },
                react_1.default.createElement("h4", null, t('MANUAL.QUEUE_LIST_PAGE_FOOTER.MODERATION_QUEUES_TITLE')),
                react_1.default.createElement("p", null, t('MANUAL.QUEUE_LIST_PAGE_FOOTER.MODERATION_QUEUES_INFO'))),
            react_1.default.createElement("div", { className: "col-md-5 col-md-offset-1" },
                react_1.default.createElement("h4", null, t('MANUAL.QUEUE_LIST_PAGE_FOOTER.DIFFERENT_QUEUES_TITLE')),
                react_1.default.createElement("p", null, t('MANUAL.QUEUE_LIST_PAGE_FOOTER.DIFFERENT_QUEUES_INFO')))),
        react_1.default.createElement(DeleteQueueModal_1.default, { onDelete: function () {
                if (!selectedQueueToRemove)
                    return;
                dispatch((0, queuesSlice_1.deleteQueue)(domain, selectedQueueToRemove.id));
            }, isOpen: isModalOpen, setIsOpen: setIsModalOpen, queueRules: transformedRules, selectedQueue: selectedQueueToRemove, angularJsDependencies: angularJsDependencies, domain: domain }),
        react_1.default.createElement(QueueNameModal_1.default, { isOpen: isQueueNameModalOpen, setIsOpen: setIsQueueNameModalOpen, onConfirm: function (queueName) {
                if (selectedQueueToEdit) {
                    editQueueName(queueName);
                    return;
                }
                addQueue(queueName);
            }, existingQueueNames: transformedQueues.map(function (item) { return item.label; }), isEditMode: selectedQueueToEdit !== undefined, selectedQueueName: selectedQueueToEdit === null || selectedQueueToEdit === void 0 ? void 0 : selectedQueueToEdit.label })));
}
exports.default = default_1;
